module.exports = __webpack_public_path__ + "img/RO.e6b4fc91.svg";